import React from 'react'
import PropTypes from 'prop-types'

import ItemCard from './ItemCard'

const InventoryDisplay = (props) => {
    const { inventory, handleEquip, handleUnequip } = props
    return (
        <div className="inventory__monitor">
            <h2>Inventory:</h2>
            <div className="inventory__monitor--listing">
                {inventory.map(item => (
                    <ItemCard
                        key={item.ID}
                        item={item}
                        clickEquip={handleEquip}
                        clickUnequip={handleUnequip}
                    />
                ))}
            </div>
        </div>
    )
}

InventoryDisplay.propTypes = {
    inventory: PropTypes.array.isRequired,
    handleEquip: PropTypes.object.isRequired,
    handleUnequip: PropTypes.object.isRequired,
}

export default InventoryDisplay
